export default __webpack_public_path__ + "static/media/image 10.ec33aaa67b075a81af1104388093a272.svg";